import React, { useCallback } from 'react'
import s from './DesktopPreHeader.less'
import UniverseButton from './UniverseButton'
import { ROUTE_ITINERARY_HOME } from '../../routes'
import { withOnlyGE } from '../Device'
import T from '../i18n/T'
import { useSelector } from 'react-redux'
import { selectIsHomePage } from '../../store/history/history.selectors'
import { navigateToHomepage } from '../../store/history/history.actions'
import { useAction } from '../utils/react-redux'
import { generateFullRoute } from '../router/routeUtils'
import UserButton from '../UserAccount/UserButton'
import { selectIsUserAccountEnabled } from '../../store/userAccount/userAccount.selectors'
import { selectItineraryOptions } from '../../store/history/history.navigate.selectors'
import iconItinerary from '../genericComponents/assets/itinerary.svg'

const DesktopPreHeader = () => {
  const homePage = useSelector(selectIsHomePage)
  const itineraryOptions = useSelector(selectItineraryOptions)

  const execNavigateToHomepage = useAction(navigateToHomepage)
  const onClickToHomepage = useCallback(
    e => {
      e.preventDefault()
      execNavigateToHomepage()
    },
    [execNavigateToHomepage]
  )

  const shouldDisplayUserAccount = useSelector(selectIsUserAccountEnabled)

  return (
    <div className={s.root}>
      {shouldDisplayUserAccount && <UserButton />}
      <a href="/" className={s.logo} title="Mappy" onClick={onClickToHomepage}>
        Mappy
      </a>
      <div className={s.universeButtons}>
        <UniverseButton
          url={iconItinerary}
          text={<T id="universes.itineraries" />}
          active={homePage}
          link={generateFullRoute(ROUTE_ITINERARY_HOME)}
          {...itineraryOptions}
        />
      </div>
    </div>
  )
}

export default withOnlyGE(DesktopPreHeader)
